export const searchInteractionEventData = (payload: {
  searchQuery: string;
  searchResultCount: number;
}) => {
  const { searchQuery, searchResultCount } = payload;
  return {
    event: "view_search_results",
    param1: searchQuery,
    param2: searchResultCount.toString(),
    param4: window.document.title,
  };
};
